export const urls = {
    FCMENU_EXT_PROD_URL: 'https://menu.na.aft.amazonoperations.app',
    FCMENU_EXT_BETA_URL: 'https://menu.beta.aft.amazonoperations.app',
    FCMENU_INT_PROD_URL: "https://fcmenu.amazon.com",
    FCMENU_INT_INTEG_URL: 'https://fcmenu.integ.amazon.com'
}
